import { render, staticRenderFns } from "./Committee.vue?vue&type=template&id=05333c94&scoped=true"
import script from "./Committee.vue?vue&type=script&lang=js"
export * from "./Committee.vue?vue&type=script&lang=js"
import style0 from "./Committee.vue?vue&type=style&index=0&id=05333c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05333c94",
  null
  
)

export default component.exports